import { render, staticRenderFns } from "./MaintenanceSystemDetail.vue?vue&type=template&id=19cf0e4f"
import script from "./MaintenanceSystemDetail.vue?vue&type=script&lang=ts"
export * from "./MaintenanceSystemDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports